import React from 'react';
import { GallerySection } from '../components/GallerySection';
export const GalleryPage = () => {
  return <div className="bg-white w-full" data-id="element-783">
      <GallerySection data-id="element-784" />
    </div>;
};